/* unplugin-vue-components disabled */import script from "./TabView.vue?vue&type=script&lang=tsx&setup=true"
export * from "./TabView.vue?vue&type=script&lang=tsx&setup=true"

import "./TabView.vue?vue&type=style&index=0&id=2feb3359&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2feb3359"]])

export default __exports__